import React, { useEffect, useState } from 'react';
import { Modal, Form, Button, Row, Col } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';

const EditModal = ({
    show,
    onClose,
    columns,
    rowData = {}, // Giá trị mặc định là một object rỗng
    setRowData,
    onSave,
    editableColumns,
    loadOptions,
    customerOptions, // Danh sách khách hàng
}) => {

    const [uploadedImage, setUploadedImage] = useState(''); // Lưu ảnh biên bản giao hàng (base64)
    // Cập nhật giá trị của trường `loai_chay` dựa trên `diem_di` và `diem_den`
    useEffect(() => {
        if (rowData && Object.keys(rowData).length > 0) {
            const { diem_di, diem_den } = rowData;

            if (diem_di === '' || diem_den === '') {
                setRowData((prevData) => ({ ...prevData, loai_chay: '' }));
            } else if (diem_di === diem_den) {
                setRowData((prevData) => ({
                    ...prevData,
                    loai_chay: diem_di === 'Hồ Chí Minh' ? 'Nội thành' : 'Nội tỉnh',
                }));
            } else {
                const noiVungProvinces = [
                    'Quảng Nam', 'Quảng Ngãi', 'Bình Định', 'Phú Yên', 'Khánh Hòa', 'Ninh Thuận', 'Bình Thuận',
                    'Kon Tum', 'Gia Lai', 'Đắk Lắk', 'Đắk Nông', 'Lâm Đồng', 'Bình Phước', 'Bình Dương', 'Đồng Nai',
                    'Tây Ninh', 'Bà Rịa-Vũng Tàu', 'Long An', 'Đồng Tháp', 'Tiền Giang', 'An Giang', 'Bến Tre',
                    'Vĩnh Long', 'Trà Vinh', 'Hậu Giang', 'Kiên Giang', 'Sóc Trăng', 'Bạc Liêu', 'Cà Mau', 'Hồ Chí Minh', 'Cần Thơ',
                ];

                setRowData((prevData) => ({
                    ...prevData,
                    loai_chay: noiVungProvinces.includes(diem_di) && noiVungProvinces.includes(diem_den)
                        ? 'Nội vùng'
                        : 'Bắc Nam',
                }));
            }
        }
    }, [rowData?.diem_di, rowData?.diem_den]);

    // Cập nhật giá trị khi thay đổi
    const handleFieldChange = (field, value) => {
        setRowData((prev) => ({ ...prev, [field]: value }));
    };

    // Xử lý thay đổi địa điểm với `AsyncSelect`
    const handleLocationSelectChange = (field, selectedOption) => {
        const updatedField = selectedOption ? selectedOption.mainValue : '';
        const updatedDisplayField = selectedOption ? selectedOption.displayValue : '';

        setRowData((prev) => ({
            ...prev,
            [field]: updatedDisplayField,
            [field === 'diem_di_thuc_te' ? 'diem_di' : 'diem_den']: updatedField,
        }));
    };

    // Xử lý upload ảnh và chuyển sang base64
    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setUploadedImage(reader.result); // Base64 của ảnh
                setRowData((prev) => ({ ...prev, ['bien_ban_giao_hang']: reader.result }))
            };
            reader.readAsDataURL(file);
        }
    };

    return (
        <Modal show={show} onHide={onClose} size="xl" fullscreen="xl-down" centered>
            <Modal.Header closeButton>
                <Modal.Title>Chỉnh sửa thông tin</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {rowData && Object.keys(rowData).length > 0 ? (
                    <Form>
                        <Row className="g-3">
                            {columns.map((col) => (
                                <Col md={4} key={col.value}>
                                    <Form.Group>
                                        <Form.Label>{col.label}</Form.Label>
                                        {editableColumns.includes(col.value) ? (
                                            col.value === 'ten_khach_hang' ? (
                                                <Select
                                                    options={customerOptions}
                                                    value={
                                                        rowData.ten_khach_hang
                                                            ? {
                                                                label: rowData.ten_khach_hang,
                                                                value: rowData.ten_khach_hang,
                                                            }
                                                            : null
                                                    }
                                                    onChange={(selectedOption) =>
                                                        handleFieldChange('ten_khach_hang', selectedOption?.value)
                                                    }
                                                    placeholder="Chọn khách hàng..."
                                                    isClearable
                                                />
                                            ) : col.value === 'ngay_van_chuyen' ? (
                                                <Form.Control
                                                    type="date"
                                                    value={rowData.ngay_van_chuyen || ''}
                                                    onChange={(e) =>
                                                        handleFieldChange('ngay_van_chuyen', e.target.value)
                                                    }
                                                />
                                            ) : col.value === 'loai_xe' ? (
                                                <Form.Select
                                                    value={rowData.loai_xe || ''}
                                                    onChange={(e) =>
                                                        handleFieldChange('loai_xe', e.target.value)
                                                    }
                                                >
                                                    <option value="" disabled>Chọn loại xe</option>
                                                    <option value="Khô">Khô</option>
                                                    <option value="Lạnh">Lạnh</option>
                                                </Form.Select>

                                            ) : col.value === 'don_vi_tinh' ? (
                                                <Form.Select
                                                    value={rowData.don_vi_tinh || ''}
                                                    onChange={(e) =>
                                                        handleFieldChange('don_vi_tinh', e.target.value)
                                                    }
                                                >
                                                    <option value="" disabled>Chọn đơn vị tính</option>
                                                    <option value="Khối">Khối</option>
                                                    <option value="Kiện">Kiện</option>
                                                    <option value="Chuyến">Chuyến</option>
                                                    <option value="Tấn">Tấn</option>
                                                    <option value="Km">Km</option>
                                                    <option value="CR">CR</option>
                                                    <option value="Pallet">Pallet</option>
                                                </Form.Select>
                                            ) : col.value === 'phu_phi' ? (
                                                <Form.Select
                                                    value={rowData.phu_phi || ''}
                                                    onChange={(e) =>
                                                        handleFieldChange('phu_phi', e.target.value)
                                                    }
                                                >
                                                    <option value="" disabled>Chọn phụ phí</option>
                                                    <option value="Không có">Không có</option>
                                                    <option value="Bốc xếp">Bốc xếp</option>
                                                    <option value="Neo xe">Neo xe</option>
                                                    <option value="Rớt điểm">Rớt điểm</option>
                                                </Form.Select>
                                            ) : col.value === 'loai_van_chuyen' ? (
                                                <Form.Select
                                                    value={rowData.loai_van_chuyen || ''}
                                                    onChange={(e) =>
                                                        handleFieldChange('loai_van_chuyen', e.target.value)
                                                    }
                                                >
                                                    <option value="" disabled>Chọn loại xe vận chuyển</option>
                                                    <option value="Xe KD">Xe KD</option>
                                                    <option value="Xe KV3">Xe KV3 (Vui lòng bỏ qua trường này)</option>
                                                    <option value="Xe TCT">Xe TCT (Vui lòng bỏ qua trường này)</option>
                                                    <option value="Xe Thuê Ngoài">Xe Thuê Ngoài</option>
                                                    <option value="Container Tài Hoả">Container Tài Hoả</option>
                                                    <option value="Container Tàu Thuỷ">Container Tàu Thuỷ</option>
                                                    <option value="FWD">FWD</option>
                                                </Form.Select>
                                            ) : col.value === 'trong_tai' ? (
                                                <Form.Select
                                                    value={rowData.trong_tai || ''}
                                                    onChange={(e) =>
                                                        handleFieldChange('trong_tai', e.target.value)
                                                    }
                                                >
                                                    <option value="">Chọn trọng tải</option>
                                                    {[830, 900, 1250, 1650, 1900, 1995, 2500, 3500, 3900, 4500, 4995, 5100, 5300, 5400, 6500, 6600, 8000, 13000, 17900, 'Container'].map((weight) => (
                                                        <option key={weight} value={weight}>
                                                            {weight}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            ) : col.value === 'diem_di' ||
                                                col.value === 'diem_den' ||
                                                col.value === 'diem_di_thuc_te' ||
                                                col.value === 'diem_den_thuc_te' ? (
                                                <AsyncSelect
                                                    cacheOptions
                                                    loadOptions={(inputValue) => loadOptions(inputValue, col.value)}
                                                    defaultOptions
                                                    onChange={(selectedOption) =>
                                                        handleLocationSelectChange(col.value, selectedOption)
                                                    }
                                                    placeholder={`Chọn ${col.label.toLowerCase()}...`}
                                                    isClearable
                                                    value={
                                                        rowData[col.value]
                                                            ? { label: rowData[col.value], value: rowData[col.value] }
                                                            : null
                                                    }
                                                />
                                            ) : col.value === 'bien_ban_giao_hang' ? (
                                                <>
                                                    <Form.Control
                                                        type="file"
                                                        accept="image/*"
                                                        onChange={handleImageUpload}
                                                    />
                                                    {rowData.bien_ban_giao_hang && (
                                                        <div className="mt-2">
                                                            <p>Ảnh hiện tại:</p>
                                                            <img
                                                                src={rowData.bien_ban_giao_hang}
                                                                alt="Biên Bản Giao Hàng"
                                                                style={{ maxWidth: '100%', maxHeight: '200px' }}
                                                            />
                                                        </div>
                                                    )}
                                                </>
                                            ) : (
                                                <Form.Control
                                                    type="text"
                                                    value={rowData[col.value] || ''}
                                                    onChange={(e) =>
                                                        handleFieldChange(col.value, e.target.value)
                                                    }
                                                />
                                            )
                                        ) : (
                                            <Form.Control
                                                type="text"
                                                value={rowData[col.value] || ''}
                                                readOnly
                                            />
                                        )}
                                    </Form.Group>
                                </Col>
                            ))}
                        </Row>
                    </Form>
                ) : (
                    <p className="text-center">Không có dữ liệu để chỉnh sửa</p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Đóng
                </Button>
                <Button
                    variant="primary"
                    onClick={onSave}
                    disabled={!rowData || Object.keys(rowData).length === 0} // Vô hiệu hóa nếu không có dữ liệu
                >
                    Lưu thay đổi
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditModal;
